import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as JSZip from 'jszip';
import { PagedResult } from '../../models/brand/paged-result.model';
import { RwandaSummaryViewModel } from '../../models/online/rwanda-summary-view.model';
import { RetailReportQueryModel } from '../../models/retails/retail-report-query.model';
import { BrandSummaryReportRequest } from '../../models/online/brand-summary-report-request.model';
import { BrandSummaryReportDto } from '../../models/online/brand-summary-report.model';
import { ReportField } from '../../models/online/report-field.interface';
import { BlackListFilterModel } from '../../models/online/black-list-filter.interface';
import { OnlineRequestModel } from '../../models/online/online-request.model';
import { RetailReportViewModel } from '../../models/online/retail-report-view.interface';

@Injectable({
    providedIn: 'root',
})
export class OnlineService {
    constructor(private http: HttpClient) {}

    getOnlineReport(data: any): Observable<any> {
        return this.http.get<any>(environment.url + `/api/OnlineReports`, {
            params: { ...data },
        });
    }

    getOnlineReport2(
        data: RetailReportQueryModel,
    ): Observable<PagedResult<RwandaSummaryViewModel>> {
        return this.http.post<PagedResult<RwandaSummaryViewModel>>(
            environment.url + `/api/OnlineReports/lastReportDetails2`,
            data,
        );
    }

    getOnlineSummaryReportRwanda(
        data: BrandSummaryReportRequest,
    ): Observable<PagedResult<BrandSummaryReportDto>> {
        return this.http.get<PagedResult<BrandSummaryReportDto>>(
            environment.url + `/api/OnlineReports/summary-report`,
            { params: { ...data } },
        );
    }

    // onlineReport2Excel(data: any): Observable<any> {
    //     return this.http.post<any>( environment.url + `/api/OnlineReports/lastReportDetailsExcel`, data);
    // }

    getOnlineReportSummaryDownload(data: BrandSummaryReportRequest): void {
        this.http
            .get(
                environment.url + `/api/OnlineReports/summary-report/download`,
                { params: { ...data }, responseType: 'arraybuffer' },
            )
            .subscribe((buffer: ArrayBuffer) => {
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'SummaryReport.xlsx';
                a.click();
                window.URL.revokeObjectURL(url);
            });
    }

    onlineReport2Excel(data: any) {
        // @ts-ignore
        this.http
            .post(
                environment.url + `/api/OnlineReports/lastReportDetailsExcel`,
                data,
                { responseType: 'arraybuffer' as const },
            )
            .subscribe((buffer: ArrayBuffer) => {
                const blob = new Blob([buffer], { type: 'application/xlsx' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = 'report.xlsx';
                a.click();

                window.URL.revokeObjectURL(url);
            });
    }

    downloadLast(): Observable<any> {
        return this.http.get<any>(
            environment.url + `/api/OnlineReports/lastreports`,
            { responseType: 'arraybuffer' as 'json' },
        );
    }

    downloadLastAndExtract(): Observable<any> {
        return this.http
            .get<any>(environment.url + `/api/OnlineReports/lastreports`, {
                responseType: 'arraybuffer' as 'json',
            })
            .pipe(
                switchMap((zipFileBuffer: any) => {
                    const jsZip = new JSZip();
                    return from(jsZip.loadAsync(zipFileBuffer));
                }),
                switchMap((zipFileContent: any) => {
                    return from<string>(
                        zipFileContent.file('opencv.js').async('string'),
                    );
                }),
            );
    }

    getColumnsForOnlineReport(): Observable<ReportField[]> {
        return this.http.get<ReportField[]>(
            environment.url + `/api/OnlineReports/reportfields`,
        );
    }

    deleteReport(id: any): Observable<any> {
        return this.http.delete<any>(
            environment.url + `/api/OnlineReports/${id}`,
        );
    }

    simulate(
        data: OnlineRequestModel,
    ): Observable<PagedResult<RetailReportViewModel>> {
        return this.http.post<PagedResult<RetailReportViewModel>>(
            environment.url + `/api/OnlineReports/simulation`,
            data,
        );
    }

    storeUpdateReport(data: any): Observable<any> {
        return this.http.post<any>(
            environment.url + `/api/BlackList/blackListFilterColumns`,
            data,
        );
    }

    getOnlineReportData(): Observable<BlackListFilterModel> {
        return this.http.get<BlackListFilterModel>(
            environment.url + `/api/BlackList/blackListFilterColumns`,
        );
    }
}
